import * as React from "react";
import * as ReactDOM from "react-dom";

import { Form, FormElement } from "@progress/kendo-react-form";
import { Button } from "@progress/kendo-react-buttons";
import { Stepper } from "@progress/kendo-react-layout";

import { ProductDetails } from "./components/product-details";
import { CustomerDetails } from "./components/customer-details";
import logo from "./assets/logo.png";
import { notificationState, sampleOrderDetails } from "./common/interfaces";
import PowerService from "./services/PowerServices";
import {
  Notification,
  NotificationGroup,
} from "@progress/kendo-react-notification";
import { Fade } from "@progress/kendo-react-animation";
import { Loader } from "@progress/kendo-react-indicators";
import { FormCaptcha } from "./components/form-components";
import { DeliveryDetails } from "./components/delivery-details";
import {
  ActionsLayout,
} from "@progress/kendo-react-dialogs";
import { DialogComponent } from "./common/dialog-component"
import { excludedJsonAttributes } from "./components/data";

export const App = () => {
  const [step, setStep] = React.useState(0);
  const [formState, setFormState] = React.useState({});
  const [formKey, setFormKey] = React.useState(1);
  const [steps, setSteps] = React.useState([
    { label: "Requestor Details", isValid: undefined },
    { label: "Delivery Details", isValid: undefined },
    { label: "Product Details", isValid: undefined },
  ]);
  const [showLoader, setShowLoader] = React.useState(false);
  const [captchaValue, setCaptchaValue] = React.useState<string>("");

  const lastStepIndex = steps.length - 1;
  const isLastStep = lastStepIndex === step;
  const isPreviousStepsValid =
    steps
      .slice(0, step)
      .findIndex((currentStep) => currentStep.isValid === false) === -1;
  const initialOrderDetails: sampleOrderDetails = {
    fullName: "",
    email: "",
    roleselected: "",
    organisation: "",
    bladdercontrolpads: [],
  };
  const [sampleOrderDetails, setSampleOrderDetails] =
    React.useState<sampleOrderDetails>(initialOrderDetails);
  const [notifyState, setState] = React.useState<notificationState>({
    success: false,
    error: false,
  });
  const [visible, setVisible] = React.useState(false);
  const [isError, setIsError] = React.useState(false);
  const [layout, setLayout] = React.useState<ActionsLayout>("stretched");
  const [ authToLeave, setauthToLeave] = React.useState(false);
  const [ deliveryNotification, setDeliveryNotification] = React.useState(false);
  const [ reqDeliveryNotification, setReqDeliveryNotification] = React.useState(false);

  const toggleDialog = () => {
    setVisible(!visible);
  };

  const onPlaceOrder = () => {
    setVisible(!visible);
  };

  const resetForm = () => {
    setFormKey(formKey + 1);
    setauthToLeave(false);
    setDeliveryNotification(false);
    setReqDeliveryNotification(false);
  };

  const onShowLoader = (show: boolean) => {
    setShowLoader(show);
  }

  const handleToggleAuthToLeav = () => {
    setauthToLeave(!authToLeave);
  };

  const handleToggleNotification = () => {
    setDeliveryNotification(!deliveryNotification);
  };

  const handleToggleReqNotification = () => {
    setReqDeliveryNotification(!reqDeliveryNotification);
  };

  const ToggleNotification = (flag: string) => {
    setState({ ...notifyState, [flag]: !(notifyState as any)[flag] });
    if (!notifyState.success) {
      setTimeout(() => {
        notifyState.success = false;
        setState({ ...notifyState, success: false });
      }, 5000);
    }
    if (!notifyState.error) {
      setTimeout(() => {
        setState({ ...notifyState, error: false });
      }, 5000);
    }
  };
  const stepPages = [
    <CustomerDetails
      deliveryNotification={reqDeliveryNotification}
      onToggleNotification={handleToggleReqNotification}
    />,
    <DeliveryDetails
      authToLeave={authToLeave}
      onToggleAuthToLeave={handleToggleAuthToLeav}
      deliveryNotification={deliveryNotification}
      onToggleNotification={handleToggleNotification}
    />,
    <ProductDetails showLoader={onShowLoader} />,
  ];

  React.useEffect(() => {
  }, []);

  const updateCapchaValue = (t: string) => {
    console.log("captcha value updated");
    setCaptchaValue(t);
  };

  const addUpProducts = (values: any) => {
    let allProducts: Array<string> = [];
    Object.keys(values).map((key, i) => {
      if(!excludedJsonAttributes.some(p => p === key)){
        values[key].forEach((element: string) => {
          allProducts.push(element);
        });        
      }
    });
    values.allProducts  = allProducts;
    return values;
  };
  
  const { success, error } = notifyState;

  const onStepSubmit = React.useCallback(
    async (event: any) => {
      const { isValid, values } = event;

      const currentSteps = steps.map((currentStep, index) => ({
        ...currentStep,
        isValid: index === step ? isValid : currentStep.isValid,
      }));

      setSteps(currentSteps);
      setStep(() => Math.min(step + 1, lastStepIndex));
      setFormState(values);
      console.log(values);

      if (isLastStep && isPreviousStepsValid && isValid) {
        if (!captchaValue) {
          alert("Please verify the reCAPTCHA!");
          return;
        } else {
          setShowLoader(true);
          const res = await PowerService.validateCaptcha(captchaValue);
          const data = await res.json();
          if (data.success) {            
            //make form submission            
            PowerService.triggerAutomate(JSON.stringify(addUpProducts(values)))
              .then((response: any) => {
                console.log(response.data);
                setShowLoader(false);
                setFormState({});
                resetForm();
                setStep(0);
                setIsError(false);
                toggleDialog();
              })
              .catch((e: Error) => {
                console.log(e);
                setShowLoader(false);
                setFormState({});
                resetForm();
                setStep(0);
                setIsError(true);
                toggleDialog();
              });
          } else {
            setShowLoader(false);
            alert("reCAPTCHA validation failed!");
          }
        }
        //alert(JSON.stringify(values));
      }
    },
    [steps, isLastStep, isPreviousStepsValid, step, lastStepIndex, captchaValue]
  );

  const onPrevClick = React.useCallback(
    (event: any) => {
      event.preventDefault();
      setStep(() => Math.max(step - 1, 0));
    },
    [step, setStep]
  );
  return (
    <div
      className="container"
      style={{ maxWidth: "800px", paddingBottom: "20px" }}
    >
      {showLoader && (
        <div className="loading h-100 d-flex align-items-center justify-content-center">
          <Loader size="large" type={"converging-spinner"} />
        </div>
      )}
      <div className={showLoader ? "disabled" : ""}>
        <div className="row">
          <div className="col">
            <img
              style={{ float: "left" }}
              width="75"
              height="75"
              src={logo}
              alt="Logo"
            />
            <h3 style={{ marginTop: "15px", marginLeft: "5px", float: "left" }}>
              Continence Sample Request
            </h3>
          </div>
        </div>
        <div className="row">
          <div className="col">
          Complete this form for FitRight® continence and/or Remedy® 
          skin care samples to be delivered direct to a client address. 
          Requests are generally delivered within 5 working days.
          </div>
        </div>
        <div className="row">
          <div className="col">
            <Stepper value={step} items={steps} />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <Form
              key={formKey}
              initialValues={formState}
              onSubmitClick={onStepSubmit}
              render={(formRenderProps) => (
                <div style={{ alignSelf: "center" }}>
                  <FormElement>
                    {stepPages[step]}
                    <div style={{ marginTop: "20px" }}>
                      {isLastStep && (
                        <div className="row">
                          <div className="col">
                            <div className="d-flex justify-content-center">
                              <FormCaptcha captchaValue={updateCapchaValue} />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <span
                      style={{ marginTop: "40px" }}
                      className={"k-form-separator"}
                    />
                    <div
                      style={{
                        justifyContent: "space-between",
                        alignContent: "center",
                      }}
                      className={
                        "k-form-buttons k-button k-button-md k-rounded-md k-button-solid k-button-solid-bases-end"
                      }
                    >
                      <span style={{ alignSelf: "center" }}>
                        Step {step + 1} of 3
                      </span>
                      <div>
                        {step !== 0 ? (
                          <Button
                            style={{ marginRight: "16px" }}
                            onClick={onPrevClick}
                          >
                            Previous
                          </Button>
                        ) : undefined}
                        <Button
                          themeColor={"primary"}
                          disabled={isLastStep ? !isPreviousStepsValid : false}
                          onClick={formRenderProps.onSubmit}
                        >
                          {isLastStep ? "Submit" : "Next"}
                        </Button>
                      </div>
                    </div>
                  </FormElement>
                </div>
              )}
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="d-flex justify-content-center">
              <Fade enter={true} exit={true}>
                {success && (
                  <Notification
                    type={{ style: "success", icon: true }}
                    closable={true}
                    onClose={() => setState({ ...notifyState, success: false })}
                  >
                    <span>Samples order places successfully !!!</span>
                  </Notification>
                )}
              </Fade>
              <Fade>
                {error && (
                  <Notification
                    type={{ style: "error", icon: true }}
                    closable={true}
                    onClose={() => setState({ ...notifyState, error: false })}
                  >
                    <span>Oops! Something went wrong ...</span>
                  </Notification>
                )}
              </Fade>
            </div>
          </div>
        </div>
      </div>
      {visible && (
        <DialogComponent
          title={"Place Order"}
          content={
            isError ? "There is an error in placing this order. Please contact Medline representative." :
            "Order placed successfully. Once shipped, Tracking details will be sent to your email, if opted for it." 
          }
          showOk={isError ? false : true}
          showCancel={false}
          showError={isError ? true: false}
          onOk={toggleDialog}
          onCancel={onPlaceOrder}
        />
      )}
    </div>
  );
};
